<template>
  <div>
    <b-modal ref="salesAgentInvoiceCommissionFeeModal"
             :title="title" :no-close-on-backdrop="true">
      <b-row>
        <b-col>
          <label>{{$t('labels.agents.invoice_sum')}} ({{ base_currency.code }}) :</label>
          <input class="form-control" v-model="commissionFee.sale_invoice_total_base_curr" placeholder="" :disabled="true">
        </b-col>
        <b-col>
          <label>{{$t('labels.agents.transport_fee')}} ({{ base_currency.code }}) :</label>
          <input class="form-control" v-model="commissionFee.sale_invoice_transport" placeholder="" :disabled="true">
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>{{$t('labels.common.delivered')}} :
            <b-badge size="sm" variant="primary" id="smartSearchPopover">i</b-badge>
            <b-popover target="smartSearchPopover" triggers="hover focus">
              <template slot="title">{{$t('labels.common.description')}}</template>
              {{$t('modal_dialogs.sales_agent_commission_fee.descr_label')}}
            </b-popover>
          </label>
          <input class="form-control" v-model="commissionFee.sold" placeholder="" :disabled="true">
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>{{$t('labels.common.agent')}}</label>
          <multiselect v-model="commissionFee.agent" :max-height="200"
                       placeholder="" label="name" track-by="name"
                       :disabled="true" :options="agents" :close-on-select="true"></multiselect>
        </b-col>
        <b-col>
          <label>{{$t('labels.agents.commission_type')}}</label>
          <multiselect v-model="commissionFee.commission_type" :max-height="200"
                       placeholder="" label="name" track-by="key"
                       :options="commissionTypes" :disabled="isCommFeeNotEditable"
                       :close-on-select="true"></multiselect>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>{{$t('labels.agents.commission_currency')}}</label>
          <multiselect v-model="commissionFee.currency" :max-height="200"
                       placeholder="" label="code" track-by="code"
                       :options="currencies" :disabled="isCommFeeNotEditable"
                       :close-on-select="true"></multiselect>
        </b-col>
        <b-col>
          <label>{{$t('labels.agents.commission_uom')}}</label>
          <multiselect v-model="commissionFee.measure_type" :max-height="200"
                       placeholder="" :options="measure_types" :disabled="isCommFeeNotEditable"
                       :close-on-select="true"></multiselect>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>{{$t('labels.agents.commission_value')}}</label>
          <input class="form-control" v-model="commissionFee.value" placeholder="" :disabled="isCommFeeNotEditable">
        </b-col>
        <b-col>
          <label>{{$t('labels.agents.commission_sum')}}</label>
          <input class="form-control" v-model="commissionFee.sum" placeholder="" :disabled="true">
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <label>{{$t('labels.common.notes')}}</label>
          <b-form-textarea v-model="commissionFee.notes" :disabled="isCommFeeNotEditable" placeholder="">
          </b-form-textarea>
        </b-col>
      </b-row>
      <div slot="modal-footer" class="w-100 text-right">
        <b-btn size="sm" variant="success" @click="save">
          {{$t('buttons.common.save')}}
        </b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import Multiselect from 'vue-multiselect';
  import {
    mapState
  } from 'vuex';
  import {
    setNotifyData
  } from '@/helpers/commonHelpers';
  import { notificationsRenderer } from '@/helpers/renderHelpers';

  export default {
    props: ['salesAgentInvoiceStatus'],
    components: {
      Multiselect
    },
    data() {
      return {
        commissionFee: {
          agent: '',
          commission_type: '',
          currency: '',
          sum: '',
          value: '',
          notes: '',
          measure_type: '',
          sold: '',
          sale_invoice_total_base_curr: '',
          sale_invoice_transport: '',
          invoice: {}
        },
        commissionFeeInitial: {}
      }
    },
    methods: {
      save() {
        const saveData = {
          agent: this.commissionFee.agent ? this.commissionFee.agent.id : '',
          invoice: this.commissionFee.invoice ? this.commissionFee.invoice.id : '',
          currency: this.commissionFee.currency ? this.commissionFee.currency.id : '',
          commission_type: this.commissionFee.commission_type ? this.commissionFee.commission_type.key : '',
          sum: this.commissionFee.sum,
          value: this.commissionFee.value,
          notes: this.commissionFee.notes,
          measure_type: this.commissionFee.measure_type
        };
        if (!this.isNewCommissionFee) {
          this.$http.put(`accounting/sale_agent_commission_fees/${this.commissionFee.id}/`, saveData).then((response) => {
            this.$notify(setNotifyData('Success', 'Commission fee had been updated!', 'success'));
            this.$root.$emit('updateSalesAgentInvoice', this.commissionFee.parentInvoiceID);
            this.$refs['salesAgentInvoiceCommissionFeeModal'].hide();
          }).catch((error) => {
            console.log(error);
            notificationsRenderer(error.body, 'error');
          });
        }
      },
      loadSettings() {
        this.$store.dispatch('partners/getSaleAgents');
        this.$store.dispatch('generic/getCurrencies');
        this.$store.dispatch('generic/loadCommissionTypes');
      }
    },
    mounted() {
      this.$root.$on('openSalesAgentInvoiceCommissionFeeModal', (commissionFee) => {
        if (commissionFee) {
          this.commissionFee = {...this.commissionFeeInitial, ...commissionFee}
        } else {
        }
        if (this.$refs['salesAgentInvoiceCommissionFeeModal']) {
          this.loadSettings();
          this.$refs['salesAgentInvoiceCommissionFeeModal'].show();
        }
      })
    },
    beforeDestroy() {
      this.$root.$off('openSalesAgentInvoiceCommissionFeeModal');
    },
    computed: {
      title() {
        return this.commissionFee.invoice.invoice_number ? `${this.$i18n.t('modal_dialogs.sales_agent_commission_fee.commission_fee')} ${this.commissionFee.invoice.invoice_number}` :
          `${this.$i18n.t('modal_dialogs.sales_agent_commission_fee.new_commission_fee')}`;
      },
      isNewCommissionFee() {
        return !this.commissionFee.id;
      },
      isCommFeeNotEditable() {
        //return this.salesAgentInvoiceStatus === 'approved' && this.commissionFee.currency.id === 1;
        return false;
      },
      ...mapState('generic', ['currencies', 'commissionTypes']),
      ...mapState('partners', ['agents']),
      ...mapState('woodware', ['measure_types', 'base_currency'])
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/modals/SalesAgentsInvoiceCommissionFeeModal.vue